export default __webpack_public_path__ + "static/media/scorpio-rising.0b4d9cba.webp";